import React from "react";

/**
 * Hero — 3 elementi: eyebrow (giallino) + H1 + una riga sotto (subtitle) + CTA.
 */
export const Hero = ({
  desktopImage,
  mobileImage,
  alt = "",
  eyebrow,
  title,
  subtitle,
  actions,
  contentAlign = "left",
  priority = true,
  testId = "hero",
}) => {
  return (
    <section className="hero-shell" data-testid={testId}>
      <img
        src={mobileImage}
        alt={alt}
        className="hero-img is-mobile"
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        loading="eager"
      />
      <img
        src={desktopImage}
        alt={alt}
        className="hero-img is-desktop"
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        loading="eager"
      />

      <div className="hero-overlay-desktop" aria-hidden="true" />
      <div className="hero-overlay-mobile" aria-hidden="true" />
      <div className="hero-vignette" aria-hidden="true" />

      <div className={`hero-content ${contentAlign === "center" ? "justify-center text-center" : "justify-start text-left"}`}>
        <div className={`max-w-4xl ${contentAlign === "center" ? "mx-auto" : ""}`}>
          {eyebrow && (
            <p className="hero-text inline-block px-3 py-1 rounded-sm text-sm sm:text-base font-semibold uppercase tracking-[0.3em] text-[#f5c518] mb-5 reveal">
              {eyebrow}
            </p>
          )}
          {title && (
            <h1
              className="hero-text font-display font-black uppercase tracking-tight text-white text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.02] reveal"
              style={{ animationDelay: ".05s" }}
            >
              {title}
            </h1>
          )}
          {subtitle && (
            <p
              className="hero-text mt-5 sm:mt-6 font-display text-white/95 text-xl sm:text-3xl lg:text-4xl leading-snug max-w-3xl reveal"
              style={{ animationDelay: ".2s" }}
            >
              {subtitle}
            </p>
          )}
          {actions && (
            <div
              className={`mt-8 sm:mt-10 flex flex-wrap gap-3 sm:gap-4 ${contentAlign === "center" ? "justify-center" : ""} reveal`}
              style={{ animationDelay: ".35s" }}
            >
              {actions}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
